function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var M = Object.defineProperty,
  E = Object.defineProperties;
var x = Object.getOwnPropertyDescriptors;
var C = Object.getOwnPropertySymbols;
var K = Object.prototype.hasOwnProperty,
  I = Object.prototype.propertyIsEnumerable;
var A = function A(e, t, s) {
    return t in e ? M(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: s
    }) : e[t] = s;
  },
  f = function f(e, t) {
    for (var s in t || (t = {})) K.call(t, s) && A(e, s, t[s]);
    if (C) {
      var _iterator = _createForOfIteratorHelper(C(t)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var s = _step.value;
          I.call(t, s) && A(e, s, t[s]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return e;
  },
  m = function m(e, t) {
    return E(e, x(t));
  };
import { openBlock as a, createElementBlock as c, createElementVNode as u, resolveDirective as N, normalizeClass as B, renderSlot as r, normalizeProps as h, guardReactiveProps as d, Fragment as L, renderList as D, createTextVNode as b, toDisplayString as k, createBlock as _, resolveDynamicComponent as O, createCommentVNode as w, mergeProps as P, toHandlers as j, withDirectives as v, vShow as S, createVNode as R, Transition as z, withCtx as $, withModifiers as F } from "vue";
var U = {
    props: {
      autoscroll: {
        type: Boolean,
        default: !0
      }
    },
    watch: {
      typeAheadPointer: function typeAheadPointer() {
        this.autoscroll && this.maybeAdjustScroll();
      },
      open: function open(e) {
        var _this = this;
        this.autoscroll && e && this.$nextTick(function () {
          return _this.maybeAdjustScroll();
        });
      }
    },
    methods: {
      maybeAdjustScroll: function maybeAdjustScroll() {
        var t;
        var e = ((t = this.$refs.dropdownMenu) == null ? void 0 : t.children[this.typeAheadPointer]) || !1;
        if (e) {
          var s = this.getDropdownViewport(),
            _e$getBoundingClientR = e.getBoundingClientRect(),
            n = _e$getBoundingClientR.top,
            l = _e$getBoundingClientR.bottom,
            i = _e$getBoundingClientR.height;
          if (n < s.top) return this.$refs.dropdownMenu.scrollTop = e.offsetTop;
          if (l > s.bottom) return this.$refs.dropdownMenu.scrollTop = e.offsetTop - (s.height - i);
        }
      },
      getDropdownViewport: function getDropdownViewport() {
        return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
          height: 0,
          top: 0,
          bottom: 0
        };
      }
    }
  },
  q = {
    data: function data() {
      return {
        typeAheadPointer: -1
      };
    },
    watch: {
      filteredOptions: function filteredOptions() {
        for (var e = 0; e < this.filteredOptions.length; e++) if (this.selectable(this.filteredOptions[e])) {
          this.typeAheadPointer = e;
          break;
        }
      },
      open: function open(e) {
        e && this.typeAheadToLastSelected();
      },
      selectedValue: function selectedValue() {
        this.open && this.typeAheadToLastSelected();
      }
    },
    methods: {
      typeAheadUp: function typeAheadUp() {
        for (var e = this.typeAheadPointer - 1; e >= 0; e--) if (this.selectable(this.filteredOptions[e])) {
          this.typeAheadPointer = e;
          break;
        }
      },
      typeAheadDown: function typeAheadDown() {
        for (var e = this.typeAheadPointer + 1; e < this.filteredOptions.length; e++) if (this.selectable(this.filteredOptions[e])) {
          this.typeAheadPointer = e;
          break;
        }
      },
      typeAheadSelect: function typeAheadSelect() {
        var e = this.filteredOptions[this.typeAheadPointer];
        e && this.selectable(e) && this.select(e);
      },
      typeAheadToLastSelected: function typeAheadToLastSelected() {
        this.typeAheadPointer = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
      }
    }
  },
  J = {
    props: {
      loading: {
        type: Boolean,
        default: !1
      }
    },
    data: function data() {
      return {
        mutableLoading: !1
      };
    },
    watch: {
      search: function search() {
        this.$emit("search", this.search, this.toggleLoading);
      },
      loading: function loading(e) {
        this.mutableLoading = e;
      }
    },
    methods: {
      toggleLoading: function toggleLoading() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        return e == null ? this.mutableLoading = !this.mutableLoading : this.mutableLoading = e;
      }
    }
  },
  V = function V(e, t) {
    var s = e.__vccOpts || e;
    var _iterator2 = _createForOfIteratorHelper(t),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
          n = _step2$value[0],
          l = _step2$value[1];
        s[n] = l;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return s;
  },
  H = {},
  X = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10"
  },
  Y = /* @__PURE__ */u("path", {
    d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"
  }, null, -1),
  Q = [Y];
function G(e, t) {
  return a(), c("svg", X, Q);
}
var W = /* @__PURE__ */V(H, [["render", G]]),
  Z = {},
  ee = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "10"
  },
  te = /* @__PURE__ */u("path", {
    d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
  }, null, -1),
  se = [te];
function ie(e, t) {
  return a(), c("svg", ee, se);
}
var oe = /* @__PURE__ */V(Z, [["render", ie]]),
  T = {
    Deselect: W,
    OpenIndicator: oe
  },
  ne = {
    mounted: function mounted(e, _ref) {
      var t = _ref.instance;
      if (t.appendToBody) {
        var _t$$refs$toggle$getBo = t.$refs.toggle.getBoundingClientRect(),
          s = _t$$refs$toggle$getBo.height,
          n = _t$$refs$toggle$getBo.top,
          l = _t$$refs$toggle$getBo.left,
          i = _t$$refs$toggle$getBo.width;
        var y = window.scrollX || window.pageXOffset,
          o = window.scrollY || window.pageYOffset;
        e.unbindPosition = t.calculatePosition(e, t, {
          width: i + "px",
          left: y + l + "px",
          top: o + n + s + "px"
        }), document.body.appendChild(e);
      }
    },
    unmounted: function unmounted(e, _ref2) {
      var t = _ref2.instance;
      t.appendToBody && (e.unbindPosition && typeof e.unbindPosition == "function" && e.unbindPosition(), e.parentNode && e.parentNode.removeChild(e));
    }
  };
function le(e) {
  var t = {};
  return Object.keys(e).sort().forEach(function (s) {
    t[s] = e[s];
  }), JSON.stringify(t);
}
var ae = 0;
function re() {
  return ++ae;
}
var he = {
    components: f({}, T),
    directives: {
      appendToBody: ne
    },
    mixins: [U, q, J],
    compatConfig: {
      MODE: 3
    },
    emits: ["open", "close", "update:modelValue", "search", "search:compositionstart", "search:compositionend", "search:keydown", "search:blur", "search:focus", "search:input", "option:created", "option:selecting", "option:selected", "option:deselecting", "option:deselected"],
    props: {
      modelValue: {},
      components: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      options: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      disabled: {
        type: Boolean,
        default: !1
      },
      clearable: {
        type: Boolean,
        default: !0
      },
      deselectFromDropdown: {
        type: Boolean,
        default: !1
      },
      searchable: {
        type: Boolean,
        default: !0
      },
      multiple: {
        type: Boolean,
        default: !1
      },
      placeholder: {
        type: String,
        default: ""
      },
      transition: {
        type: String,
        default: "vs__fade"
      },
      clearSearchOnSelect: {
        type: Boolean,
        default: !0
      },
      closeOnSelect: {
        type: Boolean,
        default: !0
      },
      label: {
        type: String,
        default: "label"
      },
      autocomplete: {
        type: String,
        default: "off"
      },
      reduce: {
        type: Function,
        default: function _default(e) {
          return e;
        }
      },
      selectable: {
        type: Function,
        default: function _default(e) {
          return !0;
        }
      },
      getOptionLabel: {
        type: Function,
        default: function _default(e) {
          return _typeof(e) == "object" ? e.hasOwnProperty(this.label) ? e[this.label] : console.warn("[vue-select warn]: Label key \"option.".concat(this.label, "\" does not exist in options object ").concat(JSON.stringify(e), ".\nhttps://vue-select.org/api/props.html#getoptionlabel")) : e;
        }
      },
      getOptionKey: {
        type: Function,
        default: function _default(e) {
          if (_typeof(e) != "object") return e;
          try {
            return e.hasOwnProperty("id") || e.hasOwnProperty("value") ? e.id || e.value : le(e);
          } catch (t) {
            return console.warn("[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.\nhttps://vue-select.org/api/props.html#getoptionkey", e, t);
          }
        }
      },
      onTab: {
        type: Function,
        default: function _default() {
          this.selectOnTab && !this.isComposing && this.typeAheadSelect();
        }
      },
      taggable: {
        type: Boolean,
        default: !1
      },
      tabindex: {
        type: Number,
        default: null
      },
      pushTags: {
        type: Boolean,
        default: !1
      },
      filterable: {
        type: Boolean,
        default: !0
      },
      filterBy: {
        type: Function,
        default: function _default(e, t, s) {
          return (t || "").toLocaleLowerCase().indexOf(s.toLocaleLowerCase()) > -1;
        }
      },
      filter: {
        type: Function,
        default: function _default(e, t) {
          var _this2 = this;
          return e.filter(function (s) {
            var n = _this2.getOptionLabel(s);
            return typeof n == "number" && (n = n.toString()), _this2.filterBy(s, n, t);
          });
        }
      },
      createOption: {
        type: Function,
        default: function _default(e) {
          return _typeof(this.optionList[0]) == "object" ? _defineProperty({}, this.label, e) : e;
        }
      },
      resetOnOptionsChange: {
        default: !1,
        validator: function validator(e) {
          return ["function", "boolean"].includes(_typeof(e));
        }
      },
      clearSearchOnBlur: {
        type: Function,
        default: function _default(_ref4) {
          var e = _ref4.clearSearchOnSelect,
            t = _ref4.multiple;
          return e && !t;
        }
      },
      noDrop: {
        type: Boolean,
        default: !1
      },
      inputId: {
        type: String
      },
      dir: {
        type: String,
        default: "auto"
      },
      selectOnTab: {
        type: Boolean,
        default: !1
      },
      selectOnKeyCodes: {
        type: Array,
        default: function _default() {
          return [13];
        }
      },
      searchInputQuerySelector: {
        type: String,
        default: "[type=search]"
      },
      mapKeydown: {
        type: Function,
        default: function _default(e, t) {
          return e;
        }
      },
      appendToBody: {
        type: Boolean,
        default: !1
      },
      calculatePosition: {
        type: Function,
        default: function _default(e, t, _ref5) {
          var s = _ref5.width,
            n = _ref5.top,
            l = _ref5.left;
          e.style.top = n, e.style.left = l, e.style.width = s;
        }
      },
      dropdownShouldOpen: {
        type: Function,
        default: function _default(_ref6) {
          var e = _ref6.noDrop,
            t = _ref6.open,
            s = _ref6.mutableLoading;
          return e ? !1 : t && !s;
        }
      },
      uid: {
        type: [String, Number],
        default: function _default() {
          return re();
        }
      }
    },
    data: function data() {
      return {
        search: "",
        open: !1,
        isComposing: !1,
        pushedTags: [],
        _value: [],
        deselectButtons: []
      };
    },
    computed: {
      isReducingValues: function isReducingValues() {
        return this.$props.reduce !== this.$options.props.reduce.default;
      },
      isTrackingValues: function isTrackingValues() {
        return typeof this.modelValue == "undefined" || this.isReducingValues;
      },
      selectedValue: function selectedValue() {
        var e = this.modelValue;
        return this.isTrackingValues && (e = this.$data._value), e != null && e !== "" ? [].concat(e) : [];
      },
      optionList: function optionList() {
        return this.options.concat(this.pushTags ? this.pushedTags : []);
      },
      searchEl: function searchEl() {
        return this.$slots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
      },
      scope: function scope() {
        var _this3 = this;
        var e = {
          search: this.search,
          loading: this.loading,
          searching: this.searching,
          filteredOptions: this.filteredOptions
        };
        return {
          search: {
            attributes: f({
              disabled: this.disabled,
              placeholder: this.searchPlaceholder,
              tabindex: this.tabindex,
              readonly: !this.searchable,
              id: this.inputId,
              "aria-autocomplete": "list",
              "aria-labelledby": "vs".concat(this.uid, "__combobox"),
              "aria-controls": "vs".concat(this.uid, "__listbox"),
              ref: "search",
              type: "search",
              autocomplete: this.autocomplete,
              value: this.search
            }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
              "aria-activedescendant": "vs".concat(this.uid, "__option-").concat(this.typeAheadPointer)
            } : {}),
            events: {
              compositionstart: function compositionstart() {
                return _this3.isComposing = !0;
              },
              compositionend: function compositionend() {
                return _this3.isComposing = !1;
              },
              keydown: this.onSearchKeyDown,
              keypress: this.onSearchKeyPress,
              blur: this.onSearchBlur,
              focus: this.onSearchFocus,
              input: function input(t) {
                return _this3.search = t.target.value;
              }
            }
          },
          spinner: {
            loading: this.mutableLoading
          },
          noOptions: {
            search: this.search,
            loading: this.mutableLoading,
            searching: this.searching
          },
          openIndicator: {
            attributes: {
              ref: "openIndicator",
              role: "presentation",
              class: "vs__open-indicator"
            }
          },
          listHeader: e,
          listFooter: e,
          header: m(f({}, e), {
            deselect: this.deselect
          }),
          footer: m(f({}, e), {
            deselect: this.deselect
          })
        };
      },
      childComponents: function childComponents() {
        return f(f({}, T), this.components);
      },
      stateClasses: function stateClasses() {
        return {
          "vs--open": this.dropdownOpen,
          "vs--single": !this.multiple,
          "vs--multiple": this.multiple,
          "vs--searching": this.searching && !this.noDrop,
          "vs--searchable": this.searchable && !this.noDrop,
          "vs--unsearchable": !this.searchable,
          "vs--loading": this.mutableLoading,
          "vs--disabled": this.disabled
        };
      },
      searching: function searching() {
        return !!this.search;
      },
      dropdownOpen: function dropdownOpen() {
        return this.dropdownShouldOpen(this);
      },
      searchPlaceholder: function searchPlaceholder() {
        return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
      },
      filteredOptions: function filteredOptions() {
        var e = [].concat(this.optionList);
        if (!this.filterable && !this.taggable) return e;
        var t = this.search.length ? this.filter(e, this.search, this) : e;
        if (this.taggable && this.search.length) {
          var s = this.createOption(this.search);
          this.optionExists(s) || t.unshift(s);
        }
        return t;
      },
      isValueEmpty: function isValueEmpty() {
        return this.selectedValue.length === 0;
      },
      showClearButton: function showClearButton() {
        return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
      }
    },
    watch: {
      options: function options(e, t) {
        var _this4 = this;
        var s = function s() {
          return typeof _this4.resetOnOptionsChange == "function" ? _this4.resetOnOptionsChange(e, t, _this4.selectedValue) : _this4.resetOnOptionsChange;
        };
        !this.taggable && s() && this.clearSelection(), this.modelValue && this.isTrackingValues && this.setInternalValueFromOptions(this.modelValue);
      },
      modelValue: {
        immediate: !0,
        handler: function handler(e) {
          this.isTrackingValues && this.setInternalValueFromOptions(e);
        }
      },
      multiple: function multiple() {
        this.clearSelection();
      },
      open: function open(e) {
        this.$emit(e ? "open" : "close");
      },
      search: function search(e) {
        e.length && (this.open = !0);
      }
    },
    created: function created() {
      this.mutableLoading = this.loading;
    },
    methods: {
      setInternalValueFromOptions: function setInternalValueFromOptions(e) {
        var _this5 = this;
        Array.isArray(e) ? this.$data._value = e.map(function (t) {
          return _this5.findOptionFromReducedValue(t);
        }) : this.$data._value = this.findOptionFromReducedValue(e);
      },
      select: function select(e, t) {
        this.$emit("option:selecting", e), this.isOptionSelected(e) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(e) : (this.taggable && !this.optionExists(e) && (this.$emit("option:created", e), this.pushTag(e)), this.multiple && (e = this.selectedValue.concat(e)), this.updateValue(e), this.$emit("option:selected", e));
        var _ref7 = t || {},
          s = _ref7.metaKey,
          n = _ref7.altKey,
          l = _ref7.ctrlKey;
        t && this.multiple && (s || n || l) || this.onAfterSelect(e);
      },
      deselect: function deselect(e) {
        var _this6 = this;
        this.$emit("option:deselecting", e), this.updateValue(this.selectedValue.filter(function (t) {
          return !_this6.optionComparator(t, e);
        })), this.$emit("option:deselected", e);
      },
      clearSelection: function clearSelection() {
        this.updateValue(this.multiple ? [] : null);
      },
      onAfterSelect: function onAfterSelect(e) {
        var _this7 = this;
        this.closeOnSelect && (this.open = !this.open), this.clearSearchOnSelect && (this.search = ""), this.noDrop && this.multiple && this.$nextTick(function () {
          return _this7.$refs.search.focus();
        });
      },
      updateValue: function updateValue(e) {
        var _this8 = this;
        typeof this.modelValue == "undefined" && (this.$data._value = e), e !== null && (Array.isArray(e) ? e = e.map(function (t) {
          return _this8.reduce(t);
        }) : e = this.reduce(e)), this.$emit("update:modelValue", e);
      },
      toggleDropdown: function toggleDropdown(e) {
        var t = e.target !== this.searchEl;
        t && e.preventDefault();
        var s = [].concat(_toConsumableArray(this.deselectButtons || []), [this.$refs.clearButton]);
        if (this.searchEl === void 0 || s.filter(Boolean).some(function (n) {
          return n.contains(e.target) || n === e.target;
        })) {
          e.preventDefault();
          return;
        }
        this.open && t ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
      },
      isOptionSelected: function isOptionSelected(e) {
        var _this9 = this;
        return this.selectedValue.some(function (t) {
          return _this9.optionComparator(t, e);
        });
      },
      isOptionDeselectable: function isOptionDeselectable(e) {
        return this.isOptionSelected(e) && this.deselectFromDropdown;
      },
      optionComparator: function optionComparator(e, t) {
        return this.getOptionKey(e) === this.getOptionKey(t);
      },
      findOptionFromReducedValue: function findOptionFromReducedValue(e) {
        var _this10 = this;
        var t = function t(n) {
            return JSON.stringify(_this10.reduce(n)) === JSON.stringify(e);
          },
          s = [].concat(_toConsumableArray(this.options), _toConsumableArray(this.pushedTags)).filter(t);
        return s.length === 1 ? s[0] : s.find(function (n) {
          return _this10.optionComparator(n, _this10.$data._value);
        }) || e;
      },
      closeSearchOptions: function closeSearchOptions() {
        this.open = !1, this.$emit("search:blur");
      },
      maybeDeleteValue: function maybeDeleteValue() {
        if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
          var e = null;
          this.multiple && (e = _toConsumableArray(this.selectedValue.slice(0, this.selectedValue.length - 1))), this.updateValue(e);
        }
      },
      optionExists: function optionExists(e) {
        var _this11 = this;
        return this.optionList.some(function (t) {
          return _this11.optionComparator(t, e);
        });
      },
      normalizeOptionForSlot: function normalizeOptionForSlot(e) {
        return _typeof(e) == "object" ? e : _defineProperty({}, this.label, e);
      },
      pushTag: function pushTag(e) {
        this.pushedTags.push(e);
      },
      onEscape: function onEscape() {
        this.search.length ? this.search = "" : this.open = !1;
      },
      onSearchBlur: function onSearchBlur() {
        if (this.mousedown && !this.searching) this.mousedown = !1;else {
          var e = this.clearSearchOnSelect,
            t = this.multiple;
          this.clearSearchOnBlur({
            clearSearchOnSelect: e,
            multiple: t
          }) && (this.search = ""), this.closeSearchOptions();
          return;
        }
        if (this.search.length === 0 && this.options.length === 0) {
          this.closeSearchOptions();
          return;
        }
      },
      onSearchFocus: function onSearchFocus() {
        this.open = !0, this.$emit("search:focus");
      },
      onMousedown: function onMousedown() {
        this.mousedown = !0;
      },
      onMouseUp: function onMouseUp() {
        this.mousedown = !1;
      },
      onSearchKeyDown: function onSearchKeyDown(e) {
        var _this12 = this;
        var t = function t(l) {
            return l.preventDefault(), !_this12.isComposing && _this12.typeAheadSelect();
          },
          s = {
            8: function _(l) {
              return _this12.maybeDeleteValue();
            },
            9: function _(l) {
              return _this12.onTab();
            },
            27: function _(l) {
              return _this12.onEscape();
            },
            38: function _(l) {
              if (l.preventDefault(), !_this12.open) {
                _this12.open = !0;
                return;
              }
              return _this12.typeAheadUp();
            },
            40: function _(l) {
              if (l.preventDefault(), !_this12.open) {
                _this12.open = !0;
                return;
              }
              return _this12.typeAheadDown();
            }
          };
        this.selectOnKeyCodes.forEach(function (l) {
          return s[l] = t;
        });
        var n = this.mapKeydown(s, this);
        if (typeof n[e.keyCode] == "function") return n[e.keyCode](e);
      },
      onSearchKeyPress: function onSearchKeyPress(e) {
        !this.open && e.keyCode === 32 && (e.preventDefault(), this.open = !0);
      }
    }
  },
  de = ["dir"],
  ce = ["id", "aria-expanded", "aria-owns"],
  ue = {
    ref: "selectedOptions",
    class: "vs__selected-options"
  },
  pe = ["disabled", "title", "aria-label", "onClick"],
  fe = {
    ref: "actions",
    class: "vs__actions"
  },
  ge = ["disabled"],
  ye = {
    class: "vs__spinner"
  },
  me = ["id", "aria-labelledby", "role", "tabindex"],
  be = ["id", "aria-selected", "onMouseover", "onClick"],
  _e = {
    key: 0,
    class: "vs__no-options"
  };
function Oe(e, t, s, n, l, i) {
  var y = N("append-to-body");
  return a(), c("div", {
    dir: s.dir,
    class: B(["v-select", i.stateClasses])
  }, [r(e.$slots, "header", h(d(i.scope.header))), u("div", {
    id: "vs".concat(s.uid, "__combobox"),
    ref: "toggle",
    class: "vs__dropdown-toggle",
    role: "combobox",
    "aria-expanded": i.dropdownOpen.toString(),
    "aria-owns": "vs".concat(s.uid, "__listbox"),
    "aria-label": "Search for option",
    onMousedown: t[1] || (t[1] = function (o) {
      return i.toggleDropdown(o);
    })
  }, [u("div", ue, [(a(!0), c(L, null, D(i.selectedValue, function (o, p) {
    return r(e.$slots, "selected-option-container", {
      option: i.normalizeOptionForSlot(o),
      deselect: i.deselect,
      multiple: s.multiple,
      disabled: s.disabled
    }, function () {
      return [(a(), c("span", {
        key: s.getOptionKey(o),
        class: "vs__selected"
      }, [r(e.$slots, "selected-option", h(d(i.normalizeOptionForSlot(o))), function () {
        return [b(k(s.getOptionLabel(o)), 1)];
      }), s.multiple ? (a(), c("button", {
        key: 0,
        ref_for: !0,
        ref: function ref(g) {
          return l.deselectButtons[p] = g;
        },
        disabled: s.disabled,
        type: "button",
        class: "vs__deselect",
        title: "Deselect ".concat(s.getOptionLabel(o)),
        "aria-label": "Deselect ".concat(s.getOptionLabel(o)),
        onClick: function onClick(g) {
          return i.deselect(o);
        }
      }, [(a(), _(O(i.childComponents.Deselect)))], 8, pe)) : w("", !0)]))];
    });
  }), 256)), r(e.$slots, "search", h(d(i.scope.search)), function () {
    return [u("input", P({
      class: "vs__search"
    }, i.scope.search.attributes, j(i.scope.search.events, !0)), null, 16)];
  })], 512), u("div", fe, [v(u("button", {
    ref: "clearButton",
    disabled: s.disabled,
    type: "button",
    class: "vs__clear",
    title: "Clear Selected",
    "aria-label": "Clear Selected",
    onClick: t[0] || (t[0] = function () {
      return i.clearSelection && i.clearSelection.apply(i, arguments);
    })
  }, [(a(), _(O(i.childComponents.Deselect)))], 8, ge), [[S, i.showClearButton]]), r(e.$slots, "open-indicator", h(d(i.scope.openIndicator)), function () {
    return [s.noDrop ? w("", !0) : (a(), _(O(i.childComponents.OpenIndicator), h(P({
      key: 0
    }, i.scope.openIndicator.attributes)), null, 16))];
  }), r(e.$slots, "spinner", h(d(i.scope.spinner)), function () {
    return [v(u("div", ye, "Loading...", 512), [[S, e.mutableLoading]])];
  })], 512)], 40, ce), R(z, {
    name: s.transition
  }, {
    default: $(function () {
      return [v((a(), c("ul", {
        id: "vs".concat(s.uid, "__listbox"),
        ref: "dropdownMenu",
        key: "vs".concat(s.uid, "__listbox"),
        "aria-labelledby": !!s.options && s.options.length ? "vs".concat(s.uid, "__combobox") : null,
        class: "vs__dropdown-menu",
        role: !!s.options && s.options.length ? "listbox" : "none",
        tabindex: !!s.options && s.options.length ? "-1" : null,
        onMousedown: t[2] || (t[2] = F(function () {
          return i.onMousedown && i.onMousedown.apply(i, arguments);
        }, ["prevent"])),
        onMouseup: t[3] || (t[3] = function () {
          return i.onMouseUp && i.onMouseUp.apply(i, arguments);
        })
      }, [r(e.$slots, "list-header", h(d(i.scope.listHeader))), (a(!0), c(L, null, D(i.filteredOptions, function (o, p) {
        return a(), c("li", {
          id: "vs".concat(s.uid, "__option-").concat(p),
          key: s.getOptionKey(o),
          role: "option",
          class: B(["vs__dropdown-option", {
            "vs__dropdown-option--deselect": i.isOptionDeselectable(o) && p === e.typeAheadPointer,
            "vs__dropdown-option--selected": i.isOptionSelected(o),
            "vs__dropdown-option--highlight": p === e.typeAheadPointer,
            "vs__dropdown-option--disabled": !s.selectable(o)
          }]),
          "aria-selected": p === e.typeAheadPointer ? !0 : null,
          onMouseover: function onMouseover(g) {
            return s.selectable(o) ? e.typeAheadPointer = p : null;
          },
          onClick: F(function (g) {
            return s.selectable(o) ? i.select(o, g) : null;
          }, ["prevent", "stop"])
        }, [r(e.$slots, "option", h(d(i.normalizeOptionForSlot(o))), function () {
          return [b(k(s.getOptionLabel(o)), 1)];
        })], 42, be);
      }), 128)), i.filteredOptions.length === 0 ? (a(), c("li", _e, [r(e.$slots, "no-options", h(d(i.scope.noOptions)), function () {
        return [b(" Sorry, no matching options. ")];
      })])) : w("", !0), r(e.$slots, "list-footer", h(d(i.scope.listFooter)))], 40, me)), [[S, i.dropdownOpen], [y]])];
    }),
    _: 3
  }, 8, ["name"]), r(e.$slots, "footer", h(d(i.scope.footer)))], 10, de);
}
var Se = /* @__PURE__ */V(he, [["render", Oe]]);
export { Se as default };